/* import __COLOCATED_TEMPLATE__ from './select-kit-collection.hbs'; */
import Component from "@ember/component";
export default Component.extend({
  tagName: ""
});